module.exports = __webpack_public_path__ + "static/img/3areaA_8.e4f6589.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/animal/3areaA_8.png
// module id = 806
// module chunks = 1